module.exports = __webpack_public_path__ + "img/tours-mobile.96650d86.jpg";